/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots.ali || ($protobuf.roots.ali = new $protobuf.Root()))
.addJSON({
  client_pb: {
    options: {
      go_package: "./client_pb"
    },
    nested: {
      AppraisalResult: {
        values: {
          APPRAISAL_RESULT_DEFAULT: 0,
          APPRAISAL_RESULT_TRUE: 1,
          APPRAISAL_RESULT_FALSE: 2,
          APPRAISAL_RESULT_UNKNOWN: 3,
          APPRAISAL_RESULT_COMPLEMENT: 5
        }
      },
      AppraisalReportListRequest: {
        fields: {
          seriesNum: {
            type: "string",
            id: 1
          }
        }
      },
      AppraisalReportListResponse: {
        fields: {
          errCode: {
            type: "int32",
            id: 1
          },
          errMsg: {
            type: "string",
            id: 2
          },
          seriesNum: {
            type: "string",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 4
          },
          kindEName: {
            type: "string",
            id: 5
          },
          brandId: {
            type: "int32",
            id: 6
          },
          brandEName: {
            type: "string",
            id: 7
          },
          seriesId: {
            type: "int32",
            id: 8
          },
          seriesEName: {
            type: "string",
            id: 9
          },
          appraisalTime: {
            type: "string",
            id: 10
          },
          sheetId: {
            type: "string",
            id: 11
          },
          oaid: {
            type: "string",
            id: 12
          },
          appraisalResult: {
            type: "AppraisalResult",
            id: 13
          },
          sku: {
            type: "string",
            id: 14
          },
          singleRecords: {
            rule: "repeated",
            type: "SingleRecord",
            id: 15
          }
        },
        nested: {
          SingleRecord: {
            fields: {
              pointName: {
                type: "string",
                id: 1
              },
              pointEName: {
                type: "string",
                id: 2
              },
              imageUrl: {
                type: "string",
                id: 3
              }
            }
          }
        }
      }
    }
  }
});

export { $root as default };
